import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
import { type AppDispatch, type RootState } from ".";

// prefer to import from this file to avoid circular dependency issues
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type { RootState };